export enum UITypes {
	PRIMARY = 'primary',
	MAIN = 'main',
	WARNING = 'warning',
	DANGER = 'danger',
	INFO = 'info',
	PASSIVE = 'passive',
	BLUE = 'blue',
	BLACK = 'black',
	SUCCESS = 'success',
	WHITE = 'white',
	GREY = 'grey',
	GREY_LIGHT = 'greyLight',
	VIOLET = 'violet',
}

export enum UISizes {
	NORMAL = 'normal',
	BIG = 'big',
	RECTANGLE = 'rectangle',
	BUTTON = 'button',

	SMALL = 'small',
	MEDIUM = 'medium',
	MAIN = 'main',
	LARGE = 'large',
	EXTRALARGE = 'extraLarge',
	XXL = 'XXL',
	XXXL = 'XXXL',
	EXTRASMALL = 'extraSmall',
	XXS = 'XXS',
}

export enum DatePickerType {
	DEFAULT = 'default',
	MONTH = 'month',
	RANGE = 'range',
}

export enum UITypography {
	H_1 = 'H1',
	H_2 = 'H2',
	H_3 = 'H3',
	P_1 = 'P1',
	P_2 = 'P2',
	CAPTION = 'Caption',
}

export enum UICurrencySuffix {
	DEFAULT = ' ₽',
	THOUSAND = ' тыс.₽',
	MILLION = ' млн.₽',
	NONE = '',
}

export enum UIColor {
	DEFAULT = 'ppneo-color-black',
	GREY_DARK = 'ppneo-color-grey-dark',
	GREY_DARKEST = 'ppneo-color-grey-darkest',
	BLUE = 'ppneo-color-blue',
	RED = 'ppneo-color-red',
	GREEN = 'ppneo-color-green',
	DANGER = 'ppneo-color-danger',
	WARNING = 'ppneo-color-warning',
	WHITE = 'ppneo-color-white',
}

export enum UIColors {
	DEFAULT = 'mainRegular',
	GREY_DARK1 = 'greyDark1',
	GREY_DARK2 = 'greyDark2',
	GREY_DARKEST = 'grey-darkest', //
	INFO_REGULAR = 'infoRegular',
	PRIMARY_REGULAR = 'primaryRegular',
	BLUE = 'blue',
	RED = 'red',
	GREEN = 'green',
	DANGER = 'danger',
	WHITE = 'white',
	WARNING = 'warning',
}

export enum UIPlacement {
	TOP = 'top',
	TOP_LEFT = 'topLeft',
	TOP_RIGHT = 'topRight',
	RIGHT = 'right',
	RIGHT_TOP = 'rightTop',
	RIGHT_BOTTOM = 'rightBottom',
	BOTTOM = 'bottom',
	BOTTOM_LEFT = 'bottomLeft',
	BOTTOM_RIGHT = 'bottomRight',
	LEFT = 'left',
	LEFT_TOP = 'leftTop',
	LEFT_BOTTOM = 'leftBottom',
}

export enum UIDirection {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal',
}

export enum UITrigger {
	CLICK = 'click',
	HOVER = 'hover',
}

export enum UIHtmlType {
	SUBMIT = 'submit',
	RESET = 'reset',
	BUTTON = 'button',
}
